import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Form, Col } from "react-bootstrap";
import {
  setPostalCode,
  setStreetNumber,
  setComplement,
  setStateLocation,
  setCityLocation,
  setStreet,
  setDistrict,
} from "./actions";

import { setLoading } from "@inspinia-react/actions";

import CityLocation from "./city-location";
import StateLocation from "./state-location";
import PostalCode from "./postal-code";
import Disctrict from "./disctrict";
import { mapTest } from "../../pages/products/map.test";

function Address(props) {
  return (
    <React.Fragment>
      <Form>
        <Form.Row>
          {props.hidePostalCode ?
            <div /> :
            <Form.Group as={Col} controlId="">
              <PostalCode />
            </Form.Group>
          }

          {props.onlyStateCity ?
            <div /> :
            <Form.Group as={Col} controlId="">
              Número
              <Form.Control
                disabled={props.loading}
                type="number"
                data-address-street-number
                id={mapTest.createClient.clientAddressNumber}
                value={props.streetNumber}
                onChange={(e) => props.setStreetNumber(e.target.value)}
              />
            </Form.Group>
          }
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} className={!props.onlyStateCity ? "col-lg-4 col-12" : ""} controlId="">
            <StateLocation unavailableStates={props.unavailableStates} />
          </Form.Group>

          <Form.Group as={Col} className={!props.onlyStateCity ? "col-lg-4 col-12" : ""} controlId="">
            <CityLocation />
          </Form.Group>
          {props.onlyStateCity ?
            <div /> :
            <Form.Group as={Col} className="col-lg-4 col-12" controlId="">
              <Disctrict />
            </Form.Group>
          }
        </Form.Row>
        <div className="row">
          <Form.Group as={Col} controlId="">
            Rua
            <Form.Control
              data-address-street
              value={props.street}
              id={mapTest.createClient.clientAddressStreet}
              disabled={props.loading}
              onChange={(e) => props.setStreet(e.target.value)}
            />
          </Form.Group>
          {props.onlyStateCity ?
            <div /> :
            <Form.Group as={Col} controlId="">
              Complemento
              <Form.Control
                disabled={props.loading}
                value={props.complement}
                id={mapTest.createClient.clientAddressComplement}
                onChange={(e) => props.setComplement(e.target.value.replace(/[&$%#@\\|]/g, ''))}
                maxLength={60}
              />
              <div className='px-3 row d-flex justify-content-between'>
                <span>máx. 60 caracteres.</span>
                <span className='justify-content-end'>{props.complement.length}/60</span>
              </div>
            </Form.Group>
          }
        </div>
      </Form>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  loading: state.loading,
  cityLocation: state.cityLocation,
  complement: state.complement,
  district: state.district,
  postalCode: state.postalCode,
  stateLocation: state.stateLocation,
  streetNumber: state.streetNumber,
  street: state.street,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPostalCode,
      setStreetNumber,
      setComplement,
      setStateLocation,
      setCityLocation,
      setStreet,
      setDistrict,
      setLoading,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Address);



// WEBPACK FOOTER //
// ./src/components/parts/address-component/index.jsx